"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCustomAttributeType = void 0;
let IssueCustomAttributeType = exports.IssueCustomAttributeType = /*#__PURE__*/function (IssueCustomAttributeType) {
  IssueCustomAttributeType["Numeric"] = "numeric";
  IssueCustomAttributeType["Date"] = "date";
  IssueCustomAttributeType["Checkbox"] = "checkbox";
  IssueCustomAttributeType["Paragraph"] = "paragraph";
  IssueCustomAttributeType["List"] = "list";
  IssueCustomAttributeType["Text"] = "text";
  return IssueCustomAttributeType;
}({});
//# sourceMappingURL=IssueCustomAttributeDefinition.js.map